import { render, staticRenderFns } from "./TotalInfoDashboard.vue?vue&type=template&id=b1f5df28&scoped=true&"
import script from "./TotalInfoDashboard.vue?vue&type=script&lang=ts&"
export * from "./TotalInfoDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./TotalInfoDashboard.vue?vue&type=style&index=0&id=b1f5df28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f5df28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCard,VCol,VDataTable,VRow})
